import { Autocomplete, Box, SxProps, TextField, Typography } from '@mui/material'
import { isEqual } from 'lodash'
import { t } from 'i18next'
import { Option } from '../../components/Form/Inputs/SelectInput'
import SortWorkHoursByType from '../../store/types/enums/SortWorkHoursByType'

type AutocompleteSuggestedProjectsProps = {
  workHoursSortByFavoriteFlag: boolean
  workHoursSortByFavoriteFlagChange: (option: boolean) => void
  sxProps?: SxProps
}

export const sortWorkHoursByOptions: Option[] = [
  { value: SortWorkHoursByType.LAST_ADDED, label: 'components.settingsDialog.lastAdded' },
  { value: SortWorkHoursByType.FAVORITE, label: 'components.settingsDialog.favorite' },
]

const AutocompleteSuggestedProjects = ({
  workHoursSortByFavoriteFlag,
  workHoursSortByFavoriteFlagChange,
  sxProps,
}: AutocompleteSuggestedProjectsProps) => {
  return (
    <Autocomplete
      sx={{ width: '60%', ...sxProps }}
      value={workHoursSortByFavoriteFlag ? sortWorkHoursByOptions[1] : sortWorkHoursByOptions[0]}
      onChange={(_, newValue) => {
        workHoursSortByFavoriteFlagChange(newValue?.value === SortWorkHoursByType.FAVORITE)
      }}
      disableClearable
      aria-label={t('components.settingsDialog.suggestedProjects')}
      options={sortWorkHoursByOptions}
      getOptionLabel={option => t(option.label)}
      noOptionsText={t('page.worklog.form.projectsNotFound')}
      renderGroup={params => (
        <div key={params.key}>
          <Box sx={{ px: 1.5, py: 1 }}>
            <Typography variant="body1" sx={{ color: 'text.highEmphasis' }}>
              {params.group}
            </Typography>
          </Box>
          <Box sx={{ color: 'text.base' }}>{params.children}</Box>
        </div>
      )}
      renderInput={params => (
        <TextField {...(params as any)} size={'small'} label={t('components.settingsDialog.suggestedProjects')} />
      )}
      isOptionEqualToValue={(option, value) => {
        return isEqual(option, value)
      }}
    />
  )
}

export default AutocompleteSuggestedProjects
